import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#6D7E93\" stroke-width=\"1.5\" cx=\"7\" cy=\"7\" r=\"6.25\" /><rect fill=\"#6D7E93\" transform=\"rotate(134 13.256 12.823)\" x=\"12.506\" y=\"10.323\" width=\"1.5\" height=\"5\" rx=\".75\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol